import { type LoadGeneratorWebhook } from 'types/api/services/load-generator'

export enum WebhookState {
  ACTIVE = 'ACTIVE',
  DEACTIVATED = 'DEACTIVATED'
}

export enum WebhookType {
  TASK = 'TASK',
  STATUS_CHECK = 'STATUS_CHECK',
  LOAD_GENERATOR_TRIGGER = 'LOAD_GENERATOR_TRIGGER',
  LOAD_GENERATOR_STATUS_CHECK = 'LOAD_GENERATOR_STATUS_CHECK',
  PREREQUISITE = 'PREREQUISITE'
}

export interface Webhook {
  createdBy: string
  createdAt: string // date
  description?: string
  identifier: string
  isPrivateNetwork?: boolean
  name: string
  state: WebhookState
  teamId: string
  triggerEvents: string[] // [ "INITIALIZING", "RUNNING", "FINISHED" ]
  type: WebhookType
  updatedBy: string // date
  updatedAt: string // date
  webhookEndpoint: LoadGeneratorWebhook
}
